import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationCashbackClaimPost = {
    path: "/cashback/claim",
    method: ERouteHttpVerb.POST
};
export { routeLocationCashbackClaimPost };
